import { render, staticRenderFns } from "./main-dialog.vue?vue&type=template&id=18acfa23&scoped=true"
import script from "./main-dialog.vue?vue&type=script&lang=js"
export * from "./main-dialog.vue?vue&type=script&lang=js"
import style0 from "./main-dialog.vue?vue&type=style&index=0&id=18acfa23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18acfa23",
  null
  
)

export default component.exports